import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).catch((err: any) => {
      if (err instanceof HttpErrorResponse && err.status === 503 && err.error === 'maintenance') {
        this.router.navigate(['/maintenance']);
      }
      return Observable.throw(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/blocks/http/interceptor/maintenance.interceptor.ts